// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container-wrapper.hop-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.main-container-wrapper.hop-wrapper p {
  margin-bottom: 20px;
  padding-bottom: 5px;
  border-bottom: 1px #0abf53 solid;
}
.main-container-wrapper.hop-wrapper .hop-helper-image .modal {
  width: 90vw;
}
.main-container-wrapper.hop-wrapper .hop-helper-image .modal img {
  width: 100%;
  height: auto;
}
.main-container-wrapper.hop-wrapper strong {
  font-weight: bold;
}
.main-container-wrapper.hop-wrapper h2 {
  font-size: 36px;
  padding-bottom: 20px;
}
.main-container-wrapper.hop-wrapper .hop-error_mirakl {
  margin: 20px 0;
  padding: 10px;
}
.main-container-wrapper.hop-wrapper .hop-error_mirakl code {
  border: 1px solid #ddd;
  display: block;
  padding: 10px 20px;
  margin: 10px 0;
}

.hop-form {
  width: 600px;
  align-items: center;
}
.hop-form label:not(:first-child) {
  margin-bottom: 10px;
  margin-top: 30px;
}
.hop-form .hop-input-container {
  display: flex;
  align-items: center;
  justify-content: stretch;
}
.hop-form .hop-input-container .input-field {
  width: 90%;
}
.hop-form .hop-input-container button {
  flex: 1 1;
}

.invalid-input input {
  border: 2px red solid;
  background-color: rgba(255, 0, 0, 0.034);
}

.hop-btn_connect {
  width: 100%;
  height: 48px;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-color: #1563A3;
  color: #fff;
}
.hop-btn_connect:hover {
  background-color: #0C4879;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);
}
.hop-btn_connect .hop-logo_mirakl {
  width: 25px;
  margin-right: 10px;
}
.hop-btn_connect .hop-logo_mirakl img {
  width: 100%;
  fill: #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/HOP/HOP.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AADF;AAGE;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;AADJ;AAKI;EACE,WAAA;AAHN;AAKM;EACE,WAAA;EACA,YAAA;AAHR;AAQE;EACE,iBAAA;AANJ;AASE;EACE,eAAA;EACA,oBAAA;AAPJ;AAUE;EACE,cAAA;EACA,aAAA;AARJ;AAUI;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AARN;;AAaA;EACE,YAAA;EACA,mBAAA;AAVF;AAYE;EACE,mBAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;AAXJ;AAaI;EACE,UAAA;AAXN;AAcI;EACE,SAAA;AAZN;;AAiBA;EACE,qBAAA;EACA,wCAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAIA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;AAdF;AAgBE;EACE,yBAAA;EAGA,+CAAA;AAdJ;AAiBE;EACE,WAAA;EACA,kBAAA;AAfJ;AAiBI;EACE,WAAA;EACA,UAAA;AAfN","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.main-container-wrapper.hop-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  p {\n    margin-bottom: 20px;\n    padding-bottom: 5px;\n    border-bottom: 1px $primary-color solid;\n  }\n\n  .hop-helper-image {\n    .modal {\n      width: 90vw;\n\n      img {\n        width: 100%;\n        height: auto;\n      }\n    }\n  }\n\n  strong {\n    font-weight: bold;\n  }\n\n  h2 {\n    font-size: 36px;\n    padding-bottom: 20px;\n  }\n\n  .hop-error_mirakl {\n    margin: 20px 0;\n    padding: 10px;\n\n    code {\n      border: 1px solid #ddd; \n      display: block; \n      padding: 10px 20px;\n      margin: 10px 0;\n    }\n  }\n}\n\n.hop-form {\n  width: 600px;\n  align-items: center;\n\n  label:not(:first-child) {\n    margin-bottom: 10px;\n    margin-top: 30px;\n  }\n\n  .hop-input-container {\n    display: flex;\n    align-items: center;\n    justify-content: stretch;\n\n    .input-field {\n      width: 90%;\n    }\n\n    button {\n      flex: 1;\n    }\n  }\n}\n\n.invalid-input input {\n  border: 2px red solid;\n  background-color: rgba(255, 0, 0, 0.034);\n}\n\n.hop-btn_connect {\n  width: 100%;\n  height: 48px;\n  border-radius: 5px;\n  -webkit-transition: all 0.2s ease-in-out;\n  -moz-transition: all 0.2s ease-in-out;\n  -o-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  background-color: #1563A3;\n  color: #fff;\n\n  &:hover {\n    background-color: #0C4879;\n    -webkit-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);\n    -moz-box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);\n    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);\n  }\n\n  .hop-logo_mirakl {\n    width: 25px;\n    margin-right: 10px;\n\n    img {\n      width: 100%;\n      fill: #fff;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
